<template>
  <div class="forget-pass">
    <md-field>
      <div class="form-group">
        <md-input-item
          class="bordered"
          v-model="$route.query.mobile"
          readonly
        ></md-input-item>
      </div>
      <div class="form-group">
        <div class="form-label">{{ $t('verificationCode') }}</div>
        <md-input-item
          ref="code"
          name="code"
          class="bordered"
          v-model="form.code"
          type="digit"
          v-validate="'required|digits:6'"
          :error="errors.first('code')"
        >
          <md-button type="blue" slot="right" :inactive="codeButtonDisabled" @click="getCode">
            {{ codeButtonText }}
          </md-button>
        </md-input-item>
      </div>
      <div class="form-group">
        <div class="form-label">{{ $t('setPassword') }}</div>
        <md-input-item
          ref="password"
          name="password"
          class="bordered"
          v-model="form.password"
          type="password"
          v-validate="'required|betweenLength:8,16'"
          :error="errors.first('password')"
        >
        </md-input-item>
      </div>
      <div class="action-button">
        <md-button type="primary" :inactive="submitDisabled" @click="submit">
          {{ $t('reset') }}
        </md-button>
      </div>
    </md-field>
  </div>
</template>

<script>
import { Button, Field, FieldItem, InputItem, Selector } from 'mand-mobile'

export default {
  i18n: {
    messages: {
      en: {
        checkInfo: 'Invalid input, please check again',
        invalidPassword: 'Password should be 8 - 16 characters.',
        invalidCode: 'Invalid Code',
        requiredError: 'This field cannot be blank',
        resend: 'Resend',
        reset: 'Reset',
        resetSuccessfully: 'Reset password successfully. Please check your inbox.',
        send: 'Send',
        codeSent: 'The verification code has been sent. Please Kindly check.',
        verificationCode: 'Vertification code',
        setPassword: 'Set your password',
      },
      id: {
        checkInfo: 'Masukan tidak valid, silakan periksa info Anda',
        invalidPassword: 'Kata sandi harus terdiri dari 8 - 16 digit dan angka',
        invalidCode: 'Kode salah',
        requiredError: 'Bidang ini tidak boleh kosong',
        resend: 'Kirim ulang',
        reset: 'Atur Ulang',
        resetSuccessfully: 'Reset password successfully. Please check your inbox.',
        send: 'Kirim',
        codeSent: 'Kode verifikasi telah dikirim. Silakan periksa.',
        verificationCode: 'Kode verifikasi',
        setPassword: 'Atur kata sandi Anda',
      },
    },
  },
  components: {
    [Button.name]: Button,
    [Field.name]: Field,
    [FieldItem.name]: FieldItem,
    [InputItem.name]: InputItem,
    [Selector.name]: Selector,
  },
  data() {
    return {
      rules: {
        code: [
          {
            required: true,
            message: this.$t('requiredError'),
            trigger: 'change',
          },
          {
            min: 6,
            max: 6,
            message: this.$t('invalidCode'),
            trigger: 'change',
          },
        ],
        password: [
          {
            required: true,
            message: this.$t('requiredError'),
            trigger: 'change',
          },
          {
            min: 8,
            max: 16,
            message: this.$t('invalidPassword'),
            trigger: 'change',
          },
        ],
      },
      form: {
        code: '',
        password: '',
      },
      error: '',
      codeCountdown: null,
      codeInterval: null,
    }
  },
  computed: {
    codeButtonText() {
      if (this.codeCountdown === null) {
        return this.$t('send')
      }
      if (this.codeCountdown <= 0) {
        return this.$t('resend')
      }
      return `${this.codeCountdown}s`
    },
    codeButtonDisabled() {
      return this.codeInterval !== null
    },
    submitDisabled() {
      const enabled = this.form.code.length > 0 && this.form.password.length >= 6
      return !enabled
    },
  },
  methods: {
    clearValidate() {
      this.$nextTick(() => {
      })
    },
    startCountdown() {
      this.stopCountdown()
      this.codeCountdown = 60
      this.codeInterval = setInterval(() => {
        this.codeCountdown -= 1
        if (this.codeCountdown === 0) {
          clearInterval(this.codeInterval)
          this.codeInterval = null
        }
      }, 1000)
    },
    stopCountdown() {
      if (this.codeInterval) {
        clearInterval(this.codeInterval)
        this.codeInterval = null
      }
      this.codeCountdown = 0
    },
    async getCode() {
      this.error = null
      this.startCountdown()
      const url = `/auth/reset-password-code?phone=${this.$route.query.mobile}`
      try {
        this.$toast.loading('loading...')
        const res = await this.$http.post(url)
        switch (res.data.code) {
          case 'SUCCESS': {
            this.$toast.succeed(this.$t('codeSent'))
            break
          }
          default: {
            this.stopCountdown()
            this.error = this.$t('checkInfo')
            break
          }
        }
      } catch (error) {
        console.error(error)
        this.stopCountdown()
      } finally {
        this.$toast.hide()
      }
    },
    async submit() {
      const valid = await this.$validator.validateAll()
      if (valid) {
        try {
          this.error = null
          const username = `${this.$route.query.mobile}`
          const payload = {
            username: username.trim(),
            code: this.form.code,
            password: this.form.password,
          }
          this.$toast.loading('loading...')
          await this.$http.post('/auth/forget-password', payload)
          this.$toast.succeed(this.$t('resetSuccessfully'))
          this.$emit('done')
        } catch (error) {
          console.error(error)
        } finally {
          this.$toast.hide()
        }
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
.forget-pass {
  padding: 0 15px;
  .form-group {
    margin-bottom: 20px;
    .form-label {
      margin-bottom: 8px;
      color: #555;
      font-size: 12px;
    }
  }
  .action-button {
    padding: 0;
    margin-top: 26px;
  }
}
</style>
